import { STAFF_COLOR } from 'shared/consts';
import { DARK_TEXT_COLOR } from 'shared/consts/styleValues';
import styled from 'styled-components';

export const TooltipLabel = styled.div`
	display: flex;
	position: absolute;
	top: calc(100% + 4px);
	white-space: nowrap;
	background-color: ${STAFF_COLOR};
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	padding: 4px 8px;
	border-radius: 24px;
	color: ${DARK_TEXT_COLOR};
	opacity: 0;
	visibility: hidden;
	transition-duration: 0.2s;
  font-size: 14px;
`;

export const TooltipContainer = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 2;

	&:hover ${TooltipLabel} {
		opacity: 1;
		visibility: visible;
	}
`;
